import GroupSitesMenu from './group-sites-menu'
import NavigationMenus from './navigation-menus'

document.addEventListener('DOMContentLoaded', () => {
  window.themeNavMenus = new NavigationMenus()
  window.themeGroupSitesMenu = new GroupSitesMenu()
})
